import { render, staticRenderFns } from "./Nota.vue?vue&type=template&id=34cbbca3&scoped=true"
import script from "./Nota.vue?vue&type=script&lang=js"
export * from "./Nota.vue?vue&type=script&lang=js"
import style0 from "./Nota.vue?vue&type=style&index=0&id=34cbbca3&prod&scoped=true&lang=css"
import style1 from "./Nota.vue?vue&type=style&index=1&id=34cbbca3&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cbbca3",
  null
  
)

export default component.exports